import { h } from 'preact';
import { BASE_WIDTH, DEFAULT_ASPECT_RATIO } from 'configuration/defaults';
import { FEATURE_NAMES, supported } from 'utilities/features';

export const clippable = Annotation => class extends Annotation {
    getElementStyles(...args) {
        const styles = super.getElementStyles(...args);

        if (this.clippable) {
            styles.clipPath = `url("#${this.clipid}")`;
        }

        return styles;
    }

    get clippable() {
        return !!this.options.svg && supported(FEATURE_NAMES.CLIP_PATH);
    }

    get clipid() {
        return `clippath-${this.props.id}`;
    }

    get clippathMarkup() {
        if (!this.options.svg) {
            return null;
        }

        const { pathData, baseWidth, baseHeight } = this.options.svg,
            rootStyles = this.getElementStyles();

        // Assuming root styles dimensions will always be in %. This will not work for other dimensions
        if (rootStyles.width && /%/.test(rootStyles.width) && rootStyles.height && /%/.test(rootStyles.height)) {
            const virtualWidth = +rootStyles.width.replace('%', ''),
                virtualHeight = +rootStyles.height.replace('%', ''),
                physicalWidth = virtualWidth / 100 * BASE_WIDTH,
                physicalHeight = virtualHeight / 100 * BASE_WIDTH * DEFAULT_ASPECT_RATIO,
                scaleX = physicalWidth / baseWidth,
                scaleY = physicalHeight / baseHeight;

                return (
                    <svg width="100%">
                        <defs>
                            <clipPath id={ this.clipid }>
                                <path d={ pathData } style={ { transform: `scale(${scaleX},${scaleY})` } }/>
                            </clipPath>
                        </defs>
                    </svg>
                );
        }

        return null;
    }
}